/**
 * The statuses shown (JBWEB-1269) of an invoice that may be sent by mail
 * (JBWEB-1282): to pay, partly paid or paid, late or not ("late" comes on top
 * of a status, never instead of it); credit notes alike. Never one not
 * imported, in error, a draft nor a cancelled one.
 *
 * Twin of SENDABLE_INVOICE_STATUSES in the api's utils/invoiceSending.js,
 * which refuses the others whatever this screen lets through: a test pins
 * both lists, change them together.
 */
export const SENDABLE_INVOICE_STATUSES = Object.freeze([
  'pending',
  'partially_paid',
  'paid',
]);

export const isSendableInvoiceStatus = (status) =>
  SENDABLE_INVOICE_STATUSES.includes(status);

// What one mail click sends at most: the api refuses more selected numbers.
export const MAIL_MAX_INVOICE_NUMBERS = 200;
